const mode = "online"; // online || local_bun || local_node || local all

const domain = window.location.hostname;

if (domain === "localhost") {
  if (mode === "local_bun") {
    module.exports = {
      geoServerBaseUrl: "https://devserver.mapid.io",
      iotServerBaseUrl: "https://api.mapid.io",
      aiServerUrl: "https://alphaserver.mapid.io",
      bun_server: "http://localhost:4005",
    };
  } else if (mode === "local_node") {
    module.exports = {
      geoServerBaseUrl: "http://localhost:4004",
      iotServerBaseUrl: "https://api.mapid.io",
      aiServerUrl: "https://alphaserver.mapid.io",
      bun_server: "https://devserver.mapid.io",
    };
  } else if (mode === "local_all") {
    module.exports = {
      geoServerBaseUrl: "http://localhost:4004",
      iotServerBaseUrl: "https://api.mapid.io",
      aiServerUrl: "https://alphaserver.mapid.io",
      bun_server: "http://localhost:4005",
    };
  } else {
    module.exports = {
      geoServerBaseUrl: "https://devserver.mapid.io",
      iotServerBaseUrl: "https://api.mapid.io",
      aiServerUrl: "https://alphaserver.mapid.io",
      bun_server: "https://devserver.mapid.io",
    };
  }
} else if (domain === "geo-alpha.mapid.io") {
  module.exports = {
    geoServerBaseUrl: "https://alphaserver.mapid.io",
    iotServerBaseUrl: "https://api.mapid.io",
    aiServerUrl: "https://alphaserver.mapid.io",
    bun_server: "https://alphaserver.mapid.io",
  };
} else if (domain === "geo-beta.mapid.io") {
  module.exports = {
    geoServerBaseUrl: "https://server.mapid.io", // sementara gunakan prod backend
    iotServerBaseUrl: "https://api.mapid.io",
    aiServerUrl: "https://alphaserver.mapid.io",
    bun_server: "https://server.mapid.io",
  };
} else if (domain === "test-geo.mapid.io") {
  module.exports = {
    geoServerBaseUrl: "https://server.mapid.io", // sementara gunakan prod backend
    iotServerBaseUrl: "https://api.mapid.io",
    aiServerUrl: "https://alphaserver.mapid.io",
    bun_server: "https://server.mapid.io",
  };
} else {
  module.exports = {
    geoServerBaseUrl: "https://server.mapid.io",
    iotServerBaseUrl: "https://api.mapid.io",
    aiServerUrl: "https://alphaserver.mapid.io",
    bun_server: "https://server.mapid.io",
  };
}
